import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '../components/LoginPage.vue'
import PageNotFound from "@/components/UserPageNotFound.vue";
import ServerErrorPage from "@/components/UserPageServerError.vue";
import AuthorizedErrorPage from "@/components/UserPageAuthorized.vue";
import UserDashboard from "@/components/UserDashboard.vue";
import { isLoggedIn } from "@/middleware/auth";
import InboundDetail from '@/components/InboundDetail.vue';
import InboundSummary from '@/components/InboundSummary.vue'; 
import InventoryDetail from '@/components/InventoryDetail.vue'; 
import LogActivity from '@/components/LogActivity.vue';
import MutasiSummary from '@/components/MutasiSummary.vue';
import MutasiDetail from '@/components/MutasiDetail.vue';
import OutboundSummary from '@/components/OutboundSummary.vue';
import OutboundDetail from '@/components/OutboundDetail.vue';

import UserProfile from "@/components/users/Profile.vue";
import ChangePassword from "@/components/users/ChangePassword.vue";
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  /**
   * User
   */
  {
    path: "/profile",
    meta: {
      title: "Chain System",
    },
    name: "UserProfile",
    component: UserProfile,
  },
  {
    path: "/change-password",
    meta: {
      title: "Chain System",
    },
    name: "ChangePassword",
    component: ChangePassword,
  },

  {
    path: '/',
    name: 'UserLogin',
    meta: {
      title: "PLB LTL",
      allowAnonymous: true
    },
    component:LoginPage,
  },
  {
    path:'/inbound-detail',
    name:'inboundDetail',
    component:InboundDetail
  },
  {
    path:'/summary-inbound',
    name:'InboundSummary',
    component:InboundSummary
  },
  {
    path:'/inventory-detail',
    name:'InventoryDetail',
    component:InventoryDetail
  },
  {
    path:'/log-activity',
    name:'LogActivity',
    component:LogActivity
  },
  {
    path:'/summary-mutasi',
    name:'MutasiSummary',
    component:MutasiSummary
  },
  {
    path:'/mutasi-item',
    name:'MutasiDetail',
    component:MutasiDetail
  },
  {
    path:'/summary-outbound',
    name:'SummaryOutbound',
    component:OutboundSummary
  },
  {
    path:'/outbound-detail',
    name:'OutboundDetail',
    component:OutboundDetail
  },
  {
    path: '/dashboard',
    name: 'home',
    component: UserDashboard
  },
  {
    path: '/server-error',
    meta: {
      title: "PLB LTL",
      allowAnonymous: true
    },
    name: "ServerErrorPage",
    component: ServerErrorPage
  },
  {
    path: '/authorized-error',
    meta: {
      title: "PLB LTL",
      allowAnonymous: true
    },
    name: "AuthorizedErrorPage",
    component: AuthorizedErrorPage
  },
  {
    path: '/page-not-found',
    meta: {
      title: "PLB LTL",
      allowAnonymous: true
    },
    name: "PageNotFound",
    component: PageNotFound
  },
  {
    path: '*',
    meta: {
      title: "PLB LTL"
    },
    name: "PageNotFoundArea",
    component: PageNotFound
  },

]

const router = new VueRouter({
  mode: "history",
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  if (to.name == 'UserLogin' && isLoggedIn() || to.name == 'ForgotPassword' && isLoggedIn() || to.name == 'ResetPassword' && isLoggedIn()) {
    next({ path: '/dashboard' , prevRoute:from })

  }
  else if (!to.meta.allowAnonymous && !isLoggedIn()) {
    next({
      path: '/',
      prevRoute:from,
      query: { redirect: to.fullPath }
    })
  }
  else {
    next({prevRoute:from})
  }
});



export default router
